"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var prism_icons_1 = require("@octanner/prism-icons");
var react_i18next_1 = require("react-i18next");
var Box_1 = __importDefault(require("../Box"));
var material_1 = require("@mui/material");
var styles_1 = require("./styles");
var stepInput = function (dir) { return function (e) {
    var _a, _b;
    // Update this if structure changes
    var input = (_b = (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.previousSibling;
    if (input) {
        if (dir === 'up') {
            input.stepUp();
        }
        if (dir === 'down') {
            input.stepDown();
        }
        var event_1 = new Event('input', { bubbles: true });
        input.dispatchEvent(event_1);
    }
}; };
var clearInput = function (e) {
    var _a, _b;
    // Update this if structure changes
    var input = (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.previousSibling;
    if (input) {
        var nativeInputValueSetter = (_b = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')) === null || _b === void 0 ? void 0 : _b.set;
        nativeInputValueSetter === null || nativeInputValueSetter === void 0 ? void 0 : nativeInputValueSetter.call(input, '');
        var event_2 = new Event('input', { bubbles: true });
        input.dispatchEvent(event_2);
    }
};
var TextField = function (_a) {
    var _b;
    var _c = _a.displayCount, displayCount = _c === void 0 ? false : _c, originalError = _a.error, helperText = _a.helperText, _d = _a.maxLength, maxLength = _d === void 0 ? 500 : _d, onChange = _a.onChange, required = _a.required, helperTextProps = _a.helperTextProps, countProps = _a.countProps, _e = _a.showOptional, showOptional = _e === void 0 ? false : _e, props = __rest(_a, ["displayCount", "error", "helperText", "maxLength", "onChange", "required", "helperTextProps", "countProps", "showOptional"]);
    var t = (0, react_i18next_1.useTranslation)().t;
    var optional = required === false && showOptional;
    var _f = __read(react_1.default.useState(String(props.value || props.defaultValue || '')), 2), currentValue = _f[0], setCurrentValue = _f[1];
    react_1.default.useEffect(function () {
        if (typeof props.value === 'undefined')
            return;
        setCurrentValue(String(props.value || ''));
    }, [props.value]);
    var currentTextLength = currentValue === null || currentValue === void 0 ? void 0 : currentValue.length;
    var error = originalError || (displayCount && currentTextLength > maxLength);
    var classes = (0, react_1.useMemo)(function () {
        var _a;
        var listOfClasses = [];
        if (props.className) {
            listOfClasses.push(props.className);
        }
        if (props.multiline) {
            listOfClasses.push('MuiTextField-multiline');
        }
        if ((_a = props === null || props === void 0 ? void 0 : props.InputProps) === null || _a === void 0 ? void 0 : _a.readOnly) {
            listOfClasses.push('MuiTextField-readonly');
        }
        if (props.label) {
            var label = props.label;
            listOfClasses.push("MuiTextField-multiline-clamp-".concat(label.length > 120 ? 3 : Math.ceil(label.length / 60)));
        }
        return listOfClasses.join(' ');
    }, [
        props.className,
        props.multiline,
        props.label,
        (_b = props === null || props === void 0 ? void 0 : props.InputProps) === null || _b === void 0 ? void 0 : _b.readOnly,
    ]);
    return (react_1.default.createElement(TextField_1.default, __assign({}, props, { className: classes, error: error, onChange: function (e) {
            setCurrentValue(e.target.value);
            if (onChange)
                onChange(e);
        }, InputLabelProps: {
            sx: {
                overflowWrap: 'break-word',
            },
        }, helperText: optional || helperText || displayCount ? (react_1.default.createElement(Box_1.default, { component: "span", sx: {
                display: 'block',
            } },
            react_1.default.createElement(styles_1.HelperContainer, null,
                react_1.default.createElement(styles_1.HelperText, __assign({ "data-testid": "helper-text" }, helperTextProps, { "aria-atomic": "true", "aria-live": "off", role: currentTextLength === 0 ? 'none' : undefined, error: error }),
                    react_1.default.createElement(react_1.default.Fragment, null,
                        optional && (react_1.default.createElement("span", { "aria-live": currentTextLength === 0 ? undefined : 'off', "aria-hidden": currentTextLength === 0 ? undefined : 'true' }, t('prism-header:optional', 'Optional'))),
                        optional && helperText ? ' | ' : '',
                        react_1.default.createElement("span", { "aria-live": error ? 'assertive' : 'polite', role: error ? 'alert' : '' }, helperText))),
                displayCount && (react_1.default.createElement(styles_1.HelperTextCount, __assign({ className: "MuiCharacterCount", "data-testid": "character-count", "aria-hidden": !(currentTextLength >= maxLength - 5 ||
                        currentTextLength === 0) }, countProps),
                    currentTextLength.toLocaleString(),
                    " /",
                    ' ',
                    maxLength.toLocaleString()))))) : undefined, select: false, SelectProps: undefined, InputProps: __assign(__assign({}, props.InputProps), { required: required, endAdornment: (function () {
                var _a, _b;
                if ((_a = props.InputProps) === null || _a === void 0 ? void 0 : _a.readOnly) {
                    return (react_1.default.createElement(material_1.Tooltip, { title: "This field cannot be edited.", placement: "bottom" },
                        react_1.default.createElement(material_1.IconButton, null,
                            react_1.default.createElement(prism_icons_1.Lock, null))));
                }
                if (props.type === 'number') {
                    return (react_1.default.createElement(styles_1.Stepper, { disabled: props.disabled },
                        react_1.default.createElement(styles_1.StepperButton, { onClick: stepInput('up') },
                            react_1.default.createElement(prism_icons_1.ArrowUp, null)),
                        react_1.default.createElement(styles_1.StepperButton, { onClick: stepInput('down') },
                            react_1.default.createElement(prism_icons_1.ArrowDown, null))));
                }
                if (props.type === 'search') {
                    return (react_1.default.createElement(styles_1.CloseButton, { onClick: clearInput, hasValue: !!currentValue }));
                }
                return (_b = props.InputProps) === null || _b === void 0 ? void 0 : _b.endAdornment;
            })() }) })));
};
exports.default = TextField;
//# sourceMappingURL=index.js.map